import { fetchGet } from '../../helpers/fetching';
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  historyLeft: [],
  historyRight: [],
};

export const patientHistorySlice = createSlice({
  name: 'patient_history',
  initialState,
  reducers: {
    setPatientHistory: (state, action) => {
      state.historyLeft = action.payload.historyLeft;
      state.historyRight = action.payload.historyRight;
    },
    clearPatientHistory: () => {
      return { ...initialState };
    },
  },
});

export const { setPatientHistory, clearPatientHistory } = patientHistorySlice.actions;
export default patientHistorySlice.reducer;

// Thunk action to fetch patient history
export const fetchPatientHistory = (patient_id) => async (dispatch) => {
  const response = await fetchGet(`patient_history/${patient_id}`);
  if (response.success) {
    dispatch(setPatientHistory(response.data));
  } else {
    dispatch(clearPatientHistory());
  }
};
